















































































import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { ProductRelationViewObject, ProductTileViewObject } from '@/types/apiServerContract';
import CondensedProductList from '@/project/product/condensed/CondensedProductList.vue';
import ProductAccessoriesSearchControl, {
    ProductRelationType
} from '@/project/product/product-tile/ProductRelationSearchControl.vue';
import Accordion from '@/core/ui-components/Accordion.vue';
import IAccordion from '@/core/ui-components/IAccordion';
import Tabs from '@/core/ui-components/tabs/Tabs.vue';
import Tab from '@/core/ui-components/tabs/Tab.vue';
import SpinnerOverlay from '@/project/spinners/SpinnerOverlay.vue';
import Temporary from '@/core/ui-components/Temporary.vue';
import dictionaryService from '@/core/translation/dictionary.service';
import urlHelper from '@/core/urlHelper.service';

@Component({
    components: { Temporary, Tabs, Tab, SpinnerOverlay, Accordion, CondensedProductList, ProductAccessoriesSearchControl }
})
export default class ProductTileMenu extends Vue {
    @Prop({ required: true }) product!: ProductTileViewObject;
    @Prop({ required: true }) bids!: ProductTileViewObject[];
    @Prop({ required: true }) accessories!: ProductRelationViewObject[];
    @Prop({ required: true }) alternatives!: ProductRelationViewObject[];
    @Prop({ required: true, default: false }) show!: boolean;

    public activated: boolean = false; // We have this to make sure we dont fetch everything on page load, but we keep it cached if the user opens the menu
    private loaded: boolean = false;
    private activeTab: string = '';

    public open() {
        this.$refs.accordion.open();
    }

    public close() {
        this.$refs.accordion.close();
    }

    private tabsChanged(tabName: string) {
        this.activeTab = tabName;
    }

    private tabsInit(tabName) {
        this.activeTab = tabName;
    }

    get labelAccessoriesText(): string | null {
        const bodyTextKey = 'Product.Relations.ProductAccessoriesRecommended.BodyText';
        return dictionaryService.exists(bodyTextKey) ? dictionaryService.get(bodyTextKey) : null;
    }

    private handleRelationLoaded(relationType: string) {
        this.loaded = true;
    }

    get ProductRelationType() {
        return ProductRelationType;
    }

    get contextForTrackingListNameRouteOrSearch(): string {
        return ((urlHelper.getTerm()) ? 'search' : this.$route.name) || '';
    }

    @Watch('show')
    onShowChange(state: boolean) {
        if (state && !this.activated) {
            this.activated = true;
        }

        state ? this.open() : this.close();
    }

    public $refs!: Vue['$refs'] & {
        accordion: IAccordion
    }
}
